import { getContractBasedDataSelector } from '@cp-shared-19/frontend-integration';
import { RootState } from 'store/rootReducer';

export const ProductRoutingDataSelector = getContractBasedDataSelector((state: RootState) => state.productRouting);
